"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    ArticleCommentRepliesClient: Symbol("ArticleCommentRepliesClient"),
    ArticleCommentRepliesRoute: Symbol("ArticleCommentRepliesRoute"),
    ArticleCommentsClient: Symbol("ArticleCommentsClient"),
    ArticleCommentsRoute: Symbol("ArticleCommentsRoute"),
    ArticleFilesClient: Symbol("ArticleFilesClient"),
    ArticleFilesRoute: Symbol("ArticleFilesRoute"),
    ArticleFilesBatchClient: Symbol("ArticleFilesBatchClient"),
    ArticleFilesBatchRoute: Symbol("ArticleFilesBatchRoute"),
    ArticleFilesStreamsClient: Symbol("ArticleFilesStreamsClient"),
    ArticleFilesStreamsRoute: Symbol("ArticleFilesStreamsRoute"),
    ArticleRatingsClient: Symbol("ArticleRatingsClient"),
    ArticleRatingsRoute: Symbol("ArticleRatingsRoute"),
    ArticleClient: Symbol("ArticleClient"),
    ArticleRoute: Symbol("ArticleRoute"),
    ArticleSettingsClient: Symbol("ArticleSettingsClient"),
    ArticleSettingsRoute: Symbol("ArticleSettingsRoute"),
    ArticleTagsClient: Symbol("ArticleTagsClient"),
    ArticleTagsRoute: Symbol("ArticleTagsRoute"),
    ArticleTagsSubscriptionsClient: Symbol("ArticleTagsSubscriptionsClient"),
    ArticleTagsSubscriptionsRoute: Symbol("ArticleTagsSubscriptionsRoute"),
    ArticleSubscriptionsArticleRoute: Symbol("ArticleSubscriptionsArticleRoute"),
    ArticleSubscriptionsCommentReportedRoute: Symbol("ArticleSubscriptionsCommentReportedRoute"),
    ArticleSubscriptionsCommentRequiresModerationRoute: Symbol("ArticleSubscriptionsCommentRequiresModerationRoute"),
    ArticleSubscriptionsRoute: Symbol("ArticleSubscriptionsRoute"),
    ArticleSubscriptionsClient: Symbol("ArticleSubscriptionsClient"),
    ArticleSubscriptionsArticleClient: Symbol("ArticleSubscriptionsArticleClient"),
    ArticleSubscriptionsCommentReportedClient: Symbol("ArticleSubscriptionsCommentReportedClient"),
    ArticleSubscriptionsCommentRequiresModerationClient: Symbol("ArticleSubscriptionsCommentRequiresModerationClient"),
    ArticleInstanceSubscriptionsClient: Symbol("ArticleInstanceSubscriptionsClient"),
    ArticleInstanceSubscriptionsRoute: Symbol("ArticleInstanceSubscriptionsRoute"),
    ArticleInstanceRatingsRoute: Symbol("ArticleInstanceRatingsRoute"),
    ArticleInstanceRatingsClient: Symbol("ArticleInstanceRatingsClient"),
    ArticleInstanceTagsRoute: Symbol("ArticleInstanceTagsRoute"),
    ArticleInstanceTagsClient: Symbol("ArticleInstanceTagsClient"),
    ArticleInstanceCommentsRoute: Symbol("ArticleInstanceCommentsRoute"),
    ArticleInstanceCommentsClient: Symbol("ArticleInstanceCommentsClient"),
    ArticleInstanceCommentRepliesRoute: Symbol("ArticleInstanceCommentRepliesRoute"),
    ArticleInstanceCommentRepliesClient: Symbol("ArticleInstanceCommentRepliesClient"),
    ArticleInstanceFilesRoute: Symbol("ArticleInstanceFilesRoute"),
    ArticleInstanceFilesClient: Symbol("ArticleInstanceFilesClient"),
    ArticleInstanceFilesStreamsRoute: Symbol("ArticleInstanceFilesStreamsRoute"),
    ArticleInstanceFilesStreamsClient: Symbol("ArticleInstanceFilesStreamsClient"),
    ArticleInstanceFilesBatchRoute: Symbol("ArticleInstanceFilesBatchRoute"),
    ArticleInstanceFilesBatchClient: Symbol("ArticleInstanceFilesBatchClient"),
    ArticleACLRoute: Symbol(" ArticleACLRoute"),
    ArticleACLClient: Symbol("ArticleACLClient"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ArticleCommentRepliesRoute).to(_1.ArticleCommentRepliesRoute);
    bind(TYPES.ArticleCommentRepliesClient).to(_1.ArticleCommentRepliesClient);
    bind(TYPES.ArticleCommentsRoute).to(_1.ArticleCommentsRoute);
    bind(TYPES.ArticleCommentsClient).to(_1.ArticleCommentsClient);
    bind(TYPES.ArticleFilesBatchRoute).to(_1.ArticleFilesBatchRoute);
    bind(TYPES.ArticleFilesBatchClient).to(_1.ArticleFilesBatchClient);
    bind(TYPES.ArticleFilesStreamsRoute).to(_1.ArticleFilesStreamsRoute);
    bind(TYPES.ArticleFilesStreamsClient).to(_1.ArticleFilesStreamsClient);
    bind(TYPES.ArticleFilesRoute).to(_1.ArticleFilesRoute);
    bind(TYPES.ArticleFilesClient).to(_1.ArticleFilesClient);
    bind(TYPES.ArticleRatingsRoute).to(_1.ArticleRatingsRoute);
    bind(TYPES.ArticleRatingsClient).to(_1.ArticleRatingsClient);
    bind(TYPES.ArticleSettingsRoute).to(_1.ArticleSettingsRoute);
    bind(TYPES.ArticleSettingsClient).to(_1.ArticleSettingsClient);
    bind(TYPES.ArticleTagsSubscriptionsRoute).to(_1.ArticleTagsSubscriptionsRoute);
    bind(TYPES.ArticleTagsSubscriptionsClient).to(_1.ArticleTagsSubscriptionsClient);
    bind(TYPES.ArticleTagsRoute).to(_1.ArticleTagsRoute);
    bind(TYPES.ArticleTagsClient).to(_1.ArticleTagsClient);
    bind(TYPES.ArticleSubscriptionsArticleRoute).to(_1.ArticleSubscriptionsArticleRoute);
    bind(TYPES.ArticleSubscriptionsCommentReportedRoute).to(_1.ArticleSubscriptionsCommentReportedRoute);
    bind(TYPES.ArticleSubscriptionsCommentRequiresModerationRoute).to(_1.ArticleSubscriptionsCommentRequiresModerationRoute);
    bind(TYPES.ArticleSubscriptionsRoute).to(_1.ArticleSubscriptionsRoute);
    bind(TYPES.ArticleSubscriptionsArticleClient).to(_1.ArticleSubscriptionsArticleClient);
    bind(TYPES.ArticleSubscriptionsCommentReportedClient).to(_1.ArticleSubscriptionsCommentReportedClient);
    bind(TYPES.ArticleSubscriptionsCommentRequiresModerationClient).to(_1.ArticleSubscriptionsCommentRequiresModerationClient);
    bind(TYPES.ArticleSubscriptionsClient).to(_1.ArticleSubscriptionsClient);
    bind(TYPES.ArticleInstanceRatingsRoute).to(_1.ArticleInstanceRatingsRoute);
    bind(TYPES.ArticleInstanceRatingsClient).to(_1.ArticleInstanceRatingsClient);
    bind(TYPES.ArticleInstanceTagsRoute).to(_1.ArticleInstanceTagsRoute);
    bind(TYPES.ArticleInstanceTagsClient).to(_1.ArticleInstanceTagsClient);
    bind(TYPES.ArticleInstanceCommentsRoute).to(_1.ArticleInstanceCommentsRoute);
    bind(TYPES.ArticleInstanceCommentsClient).to(_1.ArticleInstanceCommentsClient);
    bind(TYPES.ArticleInstanceCommentRepliesRoute).to(_1.ArticleInstanceCommentRepliesRoute);
    bind(TYPES.ArticleInstanceCommentRepliesClient).to(_1.ArticleInstanceCommentRepliesClient);
    bind(TYPES.ArticleInstanceFilesRoute).to(_1.ArticleInstanceFilesRoute);
    bind(TYPES.ArticleInstanceFilesClient).to(_1.ArticleInstanceFilesClient);
    bind(TYPES.ArticleInstanceFilesStreamsRoute).to(_1.ArticleInstanceFilesStreamsRoute);
    bind(TYPES.ArticleInstanceFilesStreamsClient).to(_1.ArticleInstanceFilesStreamsClient);
    bind(TYPES.ArticleInstanceFilesBatchRoute).to(_1.ArticleInstanceFilesBatchRoute);
    bind(TYPES.ArticleInstanceFilesBatchClient).to(_1.ArticleInstanceFilesBatchClient);
    bind(TYPES.ArticleInstanceSubscriptionsClient).to(_1.ArticleInstanceSubscriptionsClient);
    bind(TYPES.ArticleInstanceSubscriptionsRoute).to(_1.ArticleInstanceSubscriptionsRoute);
    bind(TYPES.ArticleACLRoute).to(_1.ArticleACLRoute);
    bind(TYPES.ArticleACLClient).to(_1.ArticleACLClient);
    bind(TYPES.ArticleRoute).to(_1.ArticleRoute);
    bind(TYPES.ArticleClient).to(_1.ArticleClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;
